import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ThemeController } from './ThemeController';
import { GlobalStyle } from './styles/GlobalStyle';

const container = document.getElementById('root')!;

const root = createRoot(container);

const GlobalStyleWrapper = () => <GlobalStyle/>;

root.render(
    <React.StrictMode>
        <ThemeController>
            <GlobalStyleWrapper/>
            <App/>
        </ThemeController>
    </React.StrictMode>,
);
